module.exports = "mutation ValidateEmail($email: String!) {\n  validateEmail(email: $email) {\n    isValid\n    errorMsg\n  }\n}\n"